import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DXONgSwiftUiModule } from '@dxo/ng-swift-ui';
import Components from './components';
import { DynamicComponentHostDirective } from './directives/dynamic-component-host/dynamic-component-host.directive';
import { SpanInfoEnhancedToStringPipe } from '@benefitsui/app/shared/pipes/spanInfoEnhanced/spanInfoEnhancedToString.pipe';

@NgModule({
  declarations: [Components, DynamicComponentHostDirective, SpanInfoEnhancedToStringPipe],
  imports: [CommonModule, DXONgSwiftUiModule],
  exports: [Components, DynamicComponentHostDirective, SpanInfoEnhancedToStringPipe]
})
export class BenefitsSharedModule {}
